// extracted by mini-css-extract-plugin
module.exports =  {"chartWrapper":"chartWrapper_Z56mK4LB"};